/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillarySupplierFormConfiguration
 */
export interface AncillarySupplierFormConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillarySupplierFormConfiguration
     */
    readonly ancillaries?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillarySupplierFormConfiguration
     */
    readonly ancillaryCategories?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillarySupplierFormConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
}

export function AncillarySupplierFormConfigurationFromJSON(json: any): AncillarySupplierFormConfiguration {
    return AncillarySupplierFormConfigurationFromJSONTyped(json, false);
}

export function AncillarySupplierFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillarySupplierFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaries': !exists(json, 'ancillaries') ? undefined : (json['ancillaries'] === null ? null : (json['ancillaries'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'ancillaryCategories': !exists(json, 'ancillaryCategories') ? undefined : (json['ancillaryCategories'] === null ? null : (json['ancillaryCategories'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function AncillarySupplierFormConfigurationToJSON(value?: AncillarySupplierFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


